import { styled } from '@mui/material';

export const StyledBlink = styled('span')`
    animation: blink 2s infinite;
`;
